import { render, staticRenderFns } from "./ebookReviewListPage.vue?vue&type=template&id=cffd1a74&"
import script from "./ebookReviewListPage.vue?vue&type=script&lang=js&"
export * from "./ebookReviewListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports